import { deepMerge } from '../../utils/deepMerge';
import { propAdapter } from './propAdapter';
const map = {
  primary: {
    family: '--st-dt-text-family-default' // "Amazon Ember"
  },
  monospace: {
    family: '--st-legacy-text-family-monospace' // "Amazon Ember Mono"
  }
};
export const map2Tokens = legacyThemeProperty => {
  const cssVariables = Object.entries(legacyThemeProperty).reduce((cssVariables, _ref) => {
    let [typeKey, typeValues] = _ref;
    const familyValues = Object.entries(typeValues).reduce((familyValues, _ref2) => {
      let [familyKey, familyValue] = _ref2;
      const cssVariable = map[typeKey][familyKey];
      return !cssVariable ? familyValues : {
        ...familyValues,
        [cssVariable]: familyValue
      };
    }, {});
    return {
      ...cssVariables,
      ...familyValues
    };
  }, {});
  return cssVariables;
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  const legacyThemeObject = Object.entries(legacyThemeProperty).reduce((legacyThemeObject, _ref3) => {
    let [typeKey, typeValues] = _ref3;
    const familyValues = Object.entries(typeValues).reduce((familyValues, _ref4) => {
      let [familyKey] = _ref4;
      const cssVariable = familyKey !== '' ? map[typeKey][familyKey] : undefined;
      const tokenValue = cssVariable && tokens[':root'] ? tokens[':root'][cssVariable] : undefined;
      return {
        ...familyValues,
        [familyKey]: tokenValue
      };
    }, {});
    return {
      ...legacyThemeObject,
      [typeKey]: familyValues
    };
  }, {});
  return deepMerge({}, legacyThemeProperty, legacyThemeObject);
};
export const fontFamilyPropAdapter = propAdapter({
  primary: '--st-dt-text-family-default',
  monospace: '--st-legacy-text-family-monospace'
});